import * as React from 'react';
import {FormEvent} from 'react';
import {IFamilyMember} from '@app-types/websocket/family.types';
import Button from "@components/common/button/Button";
import spawnHandoverDays from '@helpers/spawnHandoverDays';
import AdjustDays from '@components/guide/components/adjustDays.component';
import TranslateNew from "@translate/TranslateNew";

import {WithStyles, withStyles} from '@material-ui/core/styles';
import {GuideStyles} from '../guide.styles';
import ProgressBar from "@components/common/progressBar/progressBar";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import { IHoliday } from '@constants/holidays/holidayTypes';

const tn: TranslateNew = TranslateNew.getInstance();

interface IStepAdjustDaysProps extends WithStyles<typeof GuideStyles> {
    step: number;
    progress?: number | undefined;
    setStep: (step: number) => void;
    template: boolean[];
    startDate: Date;
    firstParent: IFamilyMember;
    secondParent: IFamilyMember;
    setDays: (days: boolean[]) => void;
    setHandoverDays: (days: any[]) => void;
    children: IFamilyMember[];
    holidays: {[date: string]: IHoliday} ;
    goBack: () => void;
    toggleSnackBar: (state: boolean) => void;
    setStepErrorType: (type: string) => void;
    inOnboarding: boolean;
    style?:React.CSSProperties;
    localization: 'en'|'se';
}

interface IStepAdjustDaysState {
    formValues: {
        schedule: boolean[];
    };
    formErrors: {
        schedule?: string | undefined,
    };
}

class StepAdjustDays extends React.Component<IStepAdjustDaysProps, IStepAdjustDaysState> {

    constructor(props: IStepAdjustDaysProps) {
        super(props);

        this.state = {
            formValues: {
                schedule: props.template,
            },
            formErrors: {
                schedule: undefined,
            },
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.validateSchedule = this.validateSchedule.bind(this);
        this.resetToDefault = this.resetToDefault.bind(this);
    }

    public render() {
        const {formValues, formErrors} = this.state;
        const {
            classes: style, step,
            startDate,
            secondParent,
            firstParent,
        } = this.props;

        return (
            <div className={style.container}  style={this.props.style}>
                <div className={clsx([style.topBar, style.topBarWithBackButton])}>
                    {this.props.progress && (<ProgressBar value={this.props.progress + step}/>)}
                    <Button variant="text" onClick={this.resetToDefault} className={style.backButton}>
                        <ArrowBackIcon fontSize="small"/>
                        <span style={{flex: 1}}>{tn.lang.back}</span>
                    </Button>
                </div>
                <div className={style.topContent}>
                    <Typography variant="h2">{tn.lang.signUpHandoverTitle}</Typography>
                    <Typography>
                        {tn.lang.newCalendarAdjustSubTitle +tn.lang.adjustDay+"\"."}
                    </Typography>
                </div>
                <form className={style.formGuide} onSubmit={this.handleSubmit}>
                    <div className={style.formMiddleContent}>
                        <AdjustDays
                            children={this.props.children.map((child: IFamilyMember) => (child.firstName))}
                            startDate={startDate}
                            endDate={new Date(Date.now()+63072000000)}
                            holidays={this.props.holidays}
                            schedule={formValues.schedule}
                            otherParent={secondParent.firstName}
                            myName={firstParent.firstName}
                            setSchedule={(schedule: boolean[]) => this.handleInputChange(schedule)}
                            extraWidth={this.props.inOnboarding?40:0}
                            localization={this.props.localization}
                        />
                        {formErrors.schedule &&
                            <Typography className={style.errorMessage}>{formErrors.schedule}</Typography>}
                    </div>
                    <div className={style.formBottomContent}>
                        <Button
                            type="submit"
                            variant='contained'
                            color='primary'
                            size="large"
                            fullWidth={true}
                        >
                            {tn.lang.continue}
                        </Button>
                    </div>
                </form>
            </div>);
    }

    private handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const {setDays, toggleSnackBar, setStepErrorType, setStep} = this.props;
        const {formValues} = this.state;
        const isScheduleValid = this.validateSchedule();

        if (isScheduleValid) {
            try {
                let onlyOneParent = true;
                let i = 1;

                while (i < formValues.schedule.length) {
                    if (formValues.schedule[i] !== formValues.schedule[i - 1]) {
                        onlyOneParent = false;
                        break;
                    }
                    i++;
                }

                setDays(formValues.schedule);
                if (onlyOneParent) {
                    const hd: any[] = spawnHandoverDays(formValues.schedule);
                    this.props.setHandoverDays(hd);
                } else {
                    setStep(5);
                }
            } catch (error) {
                toggleSnackBar(true);
                setStepErrorType(error);
            }
        }
    }

    private validateSchedule = (): boolean => {
        const {formValues} = this.state;

        if (formValues.schedule.length < 7) {
            this.setState((prevState) => ({
                formErrors: {
                    ...prevState.formErrors,
                    schedule: tn.lang.CalendarTemplatesErrorTemplate,
                },
            }));
            return false;
        }

        this.setState((prevState) => ({
            formErrors: {
                ...prevState.formErrors,
                schedule: undefined,
            },
        }));
        return true;
    }

    private resetToDefault = () => {
        const {setStep, template} = this.props;
        this.setState(
            {
                formValues: {
                    schedule: template,
                },
                formErrors: {
                    schedule: undefined,
                },
            }
        );

        if (this.props.goBack) {
            this.props.goBack();
        } else {
            setStep(2);
        }
    }

    private handleInputChange = (schedule: boolean[]) => {
        this.setState({formValues: {schedule}});
    }
}

export default withStyles(GuideStyles)(StepAdjustDays);



// WEBPACK FOOTER //
// ./src/components/guide/steps/stepAdjustDays.component.tsx